export default __webpack_public_path__ + "./image/799f3fa259603eb865930303fc9b100d.png";